// extracted by mini-css-extract-plugin
export default {"tit":"index_tit_POUlH","red":"index_red_M6xUE","txt":"index_txt_PKVmy"};